import { format } from 'owa-localize';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import SurfaceDragHelperBase from './SurfaceDragHelperBase';
import { addSurfaceBox } from '../../Templates';
import type { DragDropHelperProps } from './DragDropHelperProps';

import { getAllowedResizeTypesForAllDayItem } from '../../calculation/getAllowedResizeTypes';
import { observer } from 'mobx-react';
import { transformSurfaceItem } from '../../transformers/transformSurfaceItem';
import {
    CalendarSurfaceTransformProps,
    createSurfaceItemFromModel,
    DragOperationType,
    DroppableType,
} from 'owa-calendar-surface-dategrid';

/**
 * Props for the day-week drag helper
 */
export interface DayWeekDragHelperProps extends DragDropHelperProps {
    config: CalendarSurfaceTransformProps;
}

/**
 * Day/week view drag helper component
 */
@observer
export default class DayWeekDragHelper extends SurfaceDragHelperBase<DayWeekDragHelperProps, any> {
    protected get droppableType(): DroppableType {
        return DroppableType.DayWeek;
    }

    protected onNotDragging = () => {};

    protected getUnfoldedHelpers = () => {
        let { surfaceStore, config } = this.props;
        let { dragDropState } = surfaceStore;

        let helperModel = dragDropState.helperItemModel;

        let item = this.createSurfaceItemByKey(helperModel, helperModel.ItemId.Id);
        let transformedItems = transformSurfaceItem(
            surfaceStore,
            config,
            item,
            this.createSurfaceItemByIndex
        );

        // When necessary (If resizing top ot bottom) add resize grippers to the items
        let transformedDraggableItems = [];

        transformedItems.map(transformedItem => {
            if (
                surfaceStore.dragDropState.dragType == DragOperationType.ResizeBottom ||
                surfaceStore.dragDropState.dragType == DragOperationType.ResizeTop
            ) {
                let allowedResizeTypes = getAllowedResizeTypesForAllDayItem(
                    surfaceStore,
                    config.dragDropConfig,
                    item.model
                );

                let colorScheme = config.dragDropConfig.colorProvider?.(item.model);
                transformedDraggableItems.push(
                    addSurfaceBox(
                        surfaceStore,
                        item,
                        transformedItem,
                        allowedResizeTypes,
                        colorScheme
                    )
                );
            } else {
                transformedDraggableItems.push(transformedItem);
            }
        });

        return transformedDraggableItems;
    };

    private createSurfaceItemByIndex = (helperModel: CalendarEvent, itemIndex: number) => {
        let key = format(
            'helper_{0}_{1}_{2}',
            DroppableType.DayWeek,
            helperModel.ItemId.Id,
            itemIndex
        );
        return this.createSurfaceItemByKey(helperModel, key);
    };

    private createSurfaceItemByKey = (helperModel: CalendarEvent, key: string) => {
        const { config } = this.props;
        return createSurfaceItemFromModel(key, helperModel, config.columnProvider);
    };
}
